import '@/styles/tenant-tagline.css';

/**
 * DESIGN PASS 20 — the tenant's tagline, the logo's companion line.
 * A tenant's tagline belongs to that tenant. KEY-MADE has no tagline —
 * it is an acronym (KEY = Keystone, MADE = Managing Architectural Design
 * Execution) and needs no slogan. So this string is never hardcoded: it is the
 * tenant's own words, from company_settings.tagline, and if it is empty
 * nothing renders and nothing collapses.
 */
export const TenantTagline = ({ tagline, className = '', align = 'left', testid = 'tenant-tagline' }) => {
  if (!tagline || !String(tagline).trim()) return null;
  return (
    <p className={`kmd-tagline ${className}`} style={{ textAlign: align }} data-testid={testid}>
      {tagline}
    </p>
  );
};

export default TenantTagline;
